import client from 'api/client';
import { AxiosRequestConfig } from 'axios';

export function create_calendar_event(data: unknown, customConfig?: AxiosRequestConfig) {
    return client.post('/calendar-event', data, customConfig);
}
